import { render } from "./VehicleBrandList.vue?vue&type=template&id=059048a3&scoped=true"
import script from "./VehicleBrandList.vue?vue&type=script&lang=js"
export * from "./VehicleBrandList.vue?vue&type=script&lang=js"

import "./VehicleBrandList.vue?vue&type=style&index=0&id=059048a3&scoped=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059048a3"]])

export default __exports__